import React from "react";
import {Badge} from "reactstrap";
import {itemStatusLabel} from "../utils/serviceItemStatus";

// Keyed by the status code the service item API returns: green for items that
// can be added to orders, gray for retired ones.
export const STATUS_COLORS = {AC: "success", IN: "secondary"};

/** @param {{status: string}} props */
const ServiceItemStatusBadge = ({status}) => (
    <Badge pill color={STATUS_COLORS[status] ?? "secondary"}>
        {itemStatusLabel(status)}
    </Badge>
);

export default ServiceItemStatusBadge;
